export default __webpack_public_path__ + "static/media/stackable_ring.4c58995c.png";